import { Col, Container, Row } from 'react-bootstrap'; // Added Row for better layout
import FeelingResult from '../components/FeelingResult';
import FeelingGlobal from '../../Dashboard/components/FeelingGlobal'; // Note: './' or '../' based on actual path
import { useFeelings } from '../../feelingAnalysis/api/getFeelings';
import TopicsTable from '../../topics/components/TopicsTable';
import SpinerLoader from "../../../components/SpinerLoader.tsx";
import NoData from '../../../components/NoData';
import FeelingChart from '../../Dashboard/components/FeelingChart';
import { useOutletContext } from "react-router-dom";
import type { DashboardOutletContext } from "../../../components/Layouts/GlobalDashboardLayout";
import { useTopicsForSurvey } from '../../topics/hook/useTopicsForSurvey.ts';

// No need for MyPrintableComponentAProps or MyPrintableComponentA if Dashboard is the main component
// interface MyPrintableComponentAProps extends HTMLAttributes<HTMLDivElement> {
//     dataA: string;
// }

export default function Dashboard() {
    const { data: feelings, isLoading: isFeelingsLoading } = useFeelings();
    const { data: topics, isLoading: isTopicsLoading } = useTopicsForSurvey();

    const { section1Ref, section2Ref } = useOutletContext<DashboardOutletContext>();
   
    // The Dashboard component now directly returns its JSX content
    return (
        <>
            <Container fluid>
                {/* Header Row with Export Button */}
                {/* Main Content Row */}
                <Row>
                    <Col xs={12}>
                        {isFeelingsLoading || isTopicsLoading ? (
                            <div className="justify-content-center">
                                <SpinerLoader />
                            </div>
                        ) : feelings && topics ? (
                            <>
                                {/* Statistics Row */}
                                <Row className="mb-4">
                                    {/* Left Column - Feeling Results */}
                                    <Col xs={12} md={6} className="mb-3 mb-md-0 ps-0">
                                        <div ref={section1Ref} className="dashboard-section">
                                            <div className="mb-3">
                                                <FeelingResult
                                                    totalAvg={feelings.totalAvg}
                                                    totalSurveys={feelings.totalSurveys}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <FeelingGlobal
                                                    positivePercentage={feelings.positivePercentage}
                                                    neutralPercentage={feelings.neutralPercentage}
                                                    negativePercentage={feelings.negativePercentage}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    {/* Right Column - Topics and Chart */}
                                    <Col xs={12} md={6}>
                                        <div ref={section2Ref}>
                                            <div className="mb-3">
                                                {isTopicsLoading ? (
                                                    <div className="d-flex justify-content-center">
                                                        <SpinerLoader />
                                                    </div>
                                                ) : topics ? (
                                                    <TopicsTable topics={topics.slice(0, 5)} />
                                                ) : (
                                                    <NoData />
                                                )}
                                            </div>
                                            <div className="mb-3">
                                                <div style={{ height: '400px', textAlign: 'center' }}>
                                                    <FeelingChart data={feelings.averageFeelingsByData} />
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </>
                        ) : (
                            <Row>
                                <Col xs={12}>
                                    <NoData />
                                </Col>
                            </Row>
                        )}
                    </Col>
                </Row>
            </Container>
        </>
    );
}